module.exports = __webpack_public_path__ + "60545643f10923832eb89367aacb56a9.jpg";